import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
// import "./StartSelfieModal.scss";
import { uploadSelfie } from "../../services/auth.service";
import { useDispatch } from "react-redux";
import { setLoader } from "../../slice/commonSlice";
import { toast } from "react-toastify";
import { FileUploadIcon } from "../../components/Icons";
import { apiUrl } from "../../environment";
import { toast_error, toast_success } from "../../config/Constant";

const EndSelfieModal = (props) => {
  const dispatch = useDispatch();
  const [startSelfie, setStartSelfie] = useState(null);
  const [endSelfie, setEndSelfie] = useState(null);
  const onFileChange = (e, type) => {
    if (type === "start") {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setStartSelfie(e.target.result);
        };
        reader.readAsDataURL(file);
        uploadSelfieFile(type, file);
      }
    } else if (type === "end") {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setEndSelfie(e.target.result);
        };
        reader.readAsDataURL(file);
        uploadSelfieFile(type, file);
      }
    }
  };
  const uploadSelfieFile = async (type, file) => {
    const formData = new FormData();
    if (type === "start") {
      formData.append("startSelfie", file);
    }
    if (type === "end") {
      formData.append("endSelfie", file);
    }
    formData.append("jobId", props?.details?._id);

    await dispatch(setLoader(true));
    try {
      const response = await uploadSelfie(formData);
      await dispatch(setLoader(false));
      if (response?.status) {
        toast.success(response?.data?.message, toast_success);
        props.handleEndSelfieClose();
      } else {
        toast.error("No image found", toast_error);
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
      console.error("Error data:", error);
    }
  };

  const updateStatus = async () => {
    const formData = new FormData();
    formData.append("jobId", props?.details?._id);
    formData.append("endSelfie", "file");


    await dispatch(setLoader(true));
    try {
      const response = await uploadSelfie(formData);
      await dispatch(setLoader(false));
      if (response?.status) {
        toast.success(response?.data?.message, toast_success);
        props.handleEndSelfieClose();
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
      console.error("Error data:", error);
    }
  }


  const fetchImge = (img) => {
    return `${apiUrl}/${img}`;
  };
  return (
    <>
      <Modal
        show={props.endSelfieModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={() => props.handleEndSelfieClose()}
        centered
      >
        <Modal.Header
          onClick={() => props.handleEndSelfieClose()}
          closeButton
        ></Modal.Header>
        <Modal.Body>
          {/* <div className='confirm-modal-wrapper'> */}
          <div>
            <div className="start-end-selfie">
              <h5>Please upload job end photo first</h5>
            </div>
            <div className="job-content-section">
              <div className="job-content-titile"></div>
              <div className="box-wrapper browse">
                <>
                  <div>
                    <FileUploadIcon />
                  </div>
                  <div>Upload Photo</div>
                  <Button variant="outline-primary">
                    Browse
                    <input
                      type="file"
                      name="profilePic"
                      onChange={(e) => onFileChange(e, "end")}
                    />
                  </Button>
                </>
              </div>
            </div>
            <div className="start-end-selfie " style={{
              marginTop: '6px'
            }}>OR</div>

            <div id="no-upload-section" style={{ marginTop: "5px" }}>
              <h5 className="start-end-selfie ">End job without uploading selfie</h5>
              <div style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                marginTop: "15px"
              }} > <Button id="start-job" variant="primary"
              onClick={updateStatus}>End Job</Button></div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EndSelfieModal;
